




























































import Vue from "vue";
import StateSwitch from "@/components/GameBuilder/StateSwitch.vue";
import NotesPanel from "@/components/GameBuilder/NotesPanel.vue";
import PuzzleGrid from "@/components/PlayArea/PuzzleGrid.vue";
import Scaler from "@/components/Utilities/Scaler.vue";
import CreatePuzzleModal from "@/components/GameBuilder/CreatePuzzleModal.vue";
import { PuzzleService } from "../../services";
import { SwitchInfo } from "builder";
import {
  CellItem,
  CellPosition,
  Game,
  NotesModalI,
  VueConstructor,
  NotesI
} from "vue/types/vue";

import {
  PuzzleData,
  Cell,
  PuzzleBuildData,
  PuzzleBuild,
  WordStart,
  Note,
} from "../../services/vo";

export default (
  Vue as VueConstructor<
    Vue & {
      $refs: {
        notesmodal: NotesModalI;
        game: Game;
        notes: NotesI;
      };
    }
  >
).extend({
  name: "Builder",
  components: {
    PuzzleGrid,
    StateSwitch,
    NotesPanel,
    CreatePuzzleModal,
    Scaler,
  },
  provide: {
    INPUT_MODE: "text"
  },
  data() {
    return {
      editPuzzleId: this.$route.params.puzzleid,
      editPuzzle: false,
      state: {} as SwitchInfo,
      puzzle: {
        state: [],
        wordStarts: [],
        arrows: [],
        dashes: [],
      },
      notes: [] as Note[],
      cellLetters: {},
      sel: {},
      numbers: [] as Cell[],
      width: 10,
      height: 9,
      reset: 0,
      puzzleName: "",
      createSuccess: false,
      updateSuccess: false,
      success: false,
      failed: false,
      cellClicked: "",
      showNotesModal: false,
      showCreateModal: false,
      puzzleid: "",
      errorMessage: "",
      showMessage: false,
      builderMessage: "",
      newId: "",
      initPuzzle: null as any as PuzzleData,
      solution: [] as string[],
      showNotes: false,
    };
  },
  created: async function (): Promise<void> {



    if (this.editPuzzleId !== undefined) {
      try {
        let exists = await PuzzleService.puzzleExists(this.editPuzzleId);
        this.editPuzzle = true;
        this.solution = await PuzzleService.getPuzzleSolution(
          this.editPuzzleId
        );

        this.notes = await PuzzleService.getPuzzleNotes(this.editPuzzleId);
      } catch (error: any) {
        this.$router.replace({ name: "user-puzzles" }).catch(() => { });
      }
    }
    this.initPuzzle = await this.initPuzzleData();

    this.puzzleName = this.initPuzzle.puzzleName;
    this.$nextTick(() => {
      for (
        let pos: number = 0;
        pos < this.initPuzzle.wordStarts.length;
        pos++
      ) {
        const row: number = this.initPuzzle.wordStarts[pos].x;
        const col: number = this.initPuzzle.wordStarts[pos].y;
        this.toggleCornerNum(this.$refs.game.getCell(row, col));
      }
    });
  },
  mounted() {
    const el: HTMLElement | null = document.getElementById("keyboard");
    if (el != null) {
      el.style.visibility = "hidden";
    }
  },
  computed: {
    message: function (): string {
      return this.builderMessage;
    },
    createdId: function (): string {
      let id = "";
      if (this.newId !== "") {
        id = this.newId;
      }
      return id.toUpperCase();
    },
    puzzleD: function (): PuzzleData {
      return this.initPuzzle;
    },
  },

  methods: {
    initPuzzleData: async function (): Promise<PuzzleData> {
      if (this.editPuzzle) {
        let puzzleData = await PuzzleService.getPuzzleById(this.editPuzzleId);
        if (puzzleData.length > 0) this.width = puzzleData[0].getWidth();
        return puzzleData[0];
      }
      let states: string[][] = [];
      const puzzleData: PuzzleData = new PuzzleData();

      for (let i = 0; i < this.height; i++) {
        states[i] = [];
        for (let j = 0; j < this.width; j++) {
          states[i][j] = "1";
        }
      }
      puzzleData.setState(states);

      this.initPuzzle = puzzleData;
      return puzzleData;
    },
    getAllCells: function (): Cell[] {
      const cells: Cell[] = this.$refs.game.getAllCells();
      return cells;
    },
    setState: function (newState: SwitchInfo): void {
      this.state = newState;
      this.deselect();
      if (this.state.state === "6") {
        this.markStarts(true);
      }
    },
    deselect: function () {
      this.$refs.game.select();
      this.$refs.game.markBoard();
    },
    action: function (cell: Cell): void {

      this.success = false;
      this.failed = false;
      let arrow: string = "";
      switch (this.state.state) {
        case "0":
          //STATE: Write
          break;
        case "1":
          //STATE: Darken cell
          if (!cell.isDark()) {
            if (cell.hasCorner()) {
              this.toggleCornerNum(cell);
            }
            cell.setState("0");
          } else {
            cell.setState("1");
          }
          break;
        case "2":
          //STATE: Set number
          this.toggleCornerNum(cell);

          break;
        case "3":
          //STATE: Toggle arrows
          if (cell.isSpecial()) {
            cell.clear();
            cell.setState("1");
          }
          switch (cell.getArrow()) {
            case "":
              arrow = "r";
              break;
            case "r":
              arrow = "d";
              break;
          }
          cell.setArrow(arrow);
          break;

        case "4":
          //STATE: Toggle Dash
          if (cell.isSpecial()) {
            cell.clear();
            cell.setState("1");
          }
          switch (cell.getDash()) {
            case "":
              cell.setDash("r");
              break;
            case "r":
              cell.setDash("d");
              break;
            case "d":
              cell.setDash("");
              break;
          }
          break;

        case "5":
          //STATE: Set split
          if (!cell.isSpecial()) {
            if (cell.hasCorner()) {
              this.toggleCornerNum(cell);
            }
            cell.setState("2");
          } else {
            if (cell.getState() === "2") {
              cell.setState("3");
            } else {
              cell.setState("1");
            }
          }
          break;
        case "6":
          //STATE: Add notes
          if (cell.hasCorner()) {
            this.showNotesModal = true;
            this.$refs.notesmodal.setCell(cell);
          }
          break;
      }

      this.updateCornerNums();
      this.click();
    },
    id: function (x: string, y: string): string {
      return `${x}${y}`;
    },
    toggleCornerNum: function (cell: Cell): void {
      if (!cell.isSelectable()) {
        cell.setState("1");
      }

      if (!this.numbers.includes(cell)) {
        this.numbers.push(cell);
        this.numbers.sort(
          (a, b) => +`${a.getDom()._uid}` - +`${b.getDom()._uid}`
        );
      } else {
        this.numbers = this.numbers.filter(function (num) {
          if (cell.getDom()._uid === num.getDom()._uid) {
            cell.setStart("");
          }
          return (
            cell.getDom()._uid !== num.getDom()._uid &&
            num.getDom().isSelectable
          );
        });
      }
    },
    updateCornerNums: function (): void {
      for (let i = 0; i < this.numbers.length; i++) {
        this.numbers[i].setStart((i + 1).toString());
      }
    },
    markStarts: function (mark: boolean): void {
      this.$refs.game.setMarkedCells(this.numbers);
      //for (const cell of this.numbers) {
      //  cell.getDom().mark();
      //
      // // console.log(cell);
      //}
    },
    clearCell: function (cell: Cell): void { },
    resetBuilder: async function () {
      this.$router.push("/builder").catch((e) => { });
      this.reset = this.reset === 0 ? 1 : 0;
      this.numbers = new Array<Cell>();
      this.success = false;
      this.editPuzzle = false;
      await this.initPuzzleData();
      //console.log(this.$refs.game);
    },
    saveBuild: async function (puzzleName: string): Promise<void> {
      const states: string = this.getStates();
      const starts: WordStart[] = this.getStarts();
      const arrows: CellItem[] = this.getArrows();
      const dashes: CellItem[] = this.getDashes();

      let answer: string[] = [];
      try {
        answer = this.getAnswer();
      } catch (err) {
        console.log(err);
        alert("Kryssplanen är inte helt ifylld.");
        return;
      }
      const puzzleBuildData: PuzzleBuildData = new PuzzleBuildData();

      puzzleBuildData.setStates(states);
      puzzleBuildData.setWordStarts(starts);
      puzzleBuildData.setArrows(arrows);
      puzzleBuildData.setDashes(dashes);
      puzzleBuildData.setAnswer(answer);
      puzzleBuildData.setWidth(this.width);
      puzzleBuildData.setNotes(this.$refs.notes.getNotes());
      const puzzleBuild: PuzzleBuild = new PuzzleBuild(
        puzzleName,
        puzzleBuildData
      );

      if (this.editPuzzle) {
        this.doUpdate(puzzleBuild);
      } else {
        this.doSave(puzzleBuild);
      }
    },
    doSave: async function (puzzleBuild: PuzzleBuild): Promise<void> {
      try {
        this.errorMessage = "";
        const newId: string = await PuzzleService.createPuzzle(puzzleBuild);
        this.puzzleid = "";
        this.builderMessage = "Kryss sparat";
        this.createSuccess = true;
        this.newId = newId;
      } catch (error: any) {
        this.errorMessage = error.message;
        this.builderMessage = this.errorMessage;
        this.createSuccess = false;
      } finally {
        this.showMessage = true;
      }
    },
    doUpdate: async function (puzzleBuild: PuzzleBuild): Promise<void> {
      try {
        this.errorMessage = "";
        const pid = await PuzzleService.updatePuzzle(
          puzzleBuild,
          this.editPuzzleId
        );
        this.builderMessage = "Kryss uppdaterat";
        this.updateSuccess = true;
        this.newId = pid;
      } catch (error: any) {
        this.errorMessage = error.message;
        this.builderMessage = this.errorMessage;
        this.updateSuccess = false;
      } finally {
        this.showMessage = true;
      }
    },
    getStates: function () {
      let states = "";
      for (let cell of this.getAllCells()) {
        states += cell.getState();
      }
      return states;
    },
    getStarts: function () {
      let starts: WordStart[] = [];
      for (let cell of this.getAllCells()) {
        if (cell.hasCorner()) {
          const x = cell.getPos().x;
          const y = cell.getPos().y;
          const startPos: CellPosition = {
            x: x,
            y: y,
          };
          starts.push(new WordStart(x, y));
        }
      }
      // console.log(starts);
      return starts;
    },
    getArrows: function () {
      let arrows: CellItem[] = [];
      for (let cell of this.getAllCells()) {
        if (cell.getArrow() !== "") {
          const x = cell.getPos().x;
          const y = cell.getPos().y;
          const arrow = cell.getArrow();

          arrows.push({
            x: x,
            y: y,
            direction: arrow,
          });
        }
      }
      //  console.log(arrows);
      return arrows;
    },
    getDashes: function () {
      let dashes: CellItem[] = [];
      for (let cell of this.getAllCells()) {
        if (cell.getDash() !== "") {
          const x = cell.getPos().x;
          const y = cell.getPos().y;
          const dash = cell.getDash();
          dashes.push({
            x: x,
            y: y,
            direction: dash,
          });
        }
      }
      //  console.log(dashes);
      return dashes;
    },
    getAnswer: function () {
      let answer = [];
      for (let cell of this.getAllCells()) {
        if (cell.isSelectable()) {
          if (cell.getLetter() === "") {
            answer.push("_");
          } else {
            answer.push(cell.getLetter());
          }
        }
      }
      return answer;
    },
    scaleBoard: function (scale: string): void {
      switch (scale) {
        case "+":
          if (this.width < 10) {
            this.width += 1;
            this.height = this.width - 1;
            this.resetBuilder();
          }
          break;
        case "-":
          if (this.width > 5) {
            this.width -= 1;
            this.height = this.width - 1;
            this.resetBuilder();
          }
          break;
      }
    },
    closeModal: function () {
      this.showNotesModal = false;
      this.showCreateModal = false;
      this.setState(this.state);
    },
    closeConfirm: function (): void {
      this.showMessage = false;
      this.builderMessage = "";

      if (this.newId) {
        const self = this;
        this.$router
          .push({ name: "edit-puzzle", params: { puzzleid: this.newId } })
          .catch(() => {
            self.$router.go(0);
          });
      }

      this.newId = "";
    },
    click: function (): void {
      this.cellClicked = this.cellClicked === "1" ? "0" : "1";
    },
  },
  watch: {
    cellClicked: function () {
      if (this.state.state !== "0" && this.state.state !== "6") {
        this.deselect();
      }
    },
  },
});
